import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

/**
 * Styles for the activity-log JSON formatter. It reads like a code panel (subtle surface + mono
 * font) but the renderer stays a React tree so we can inject identifier/reserved Labels, entity
 * links, and humanized timestamps (which Pluma `CodeBlock` can't host). All colors use theme
 * `color` tokens (not a fixed palette) so the panel is theme-compatible in light and dark:
 * `text-code` / `text-information` / `text-accent` for the syntax colors.
 */

export const root = style(
  {
    backgroundColor: themeVars.color['overlay-tint'],
    color: themeVars.color['text-primary'],
    fontFamily: themeVars['font-family'].mono,
    fontSize: themeVars['font-size']['xxs'],
    lineHeight: 1.6,
    borderRadius: themeVars.radius['4'],
    padding: themeVars.space['200'],
    maxHeight: '400px',
    overflow: 'auto',
    whiteSpace: 'pre',
    tabSize: 2,
  },
  'log-json-formatter-root',
);

/** Nested object/array indentation with a subtle guide. */
export const nested = style(
  {
    listStyle: 'none',
    margin: 0,
    paddingLeft: themeVars.space['200'],
    borderLeft: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
  },
  'log-json-formatter-nested',
);

export const row = style({ display: 'block' }, 'log-json-formatter-row');

export const punctuation = style({ color: themeVars.color['text-secondary'] }, 'log-json-formatter-punctuation');
export const propKey = style({ color: themeVars.color['scope-action-text'] }, 'log-json-formatter-prop');
export const valueString = style({ color: themeVars.color['text-code'] }, 'log-json-formatter-string');
export const valueNumber = style({ color: themeVars.color['scope-information-text'] }, 'log-json-formatter-number');
export const valueBool = style({ color: themeVars.color['scope-caution-text'] }, 'log-json-formatter-bool');
export const valueNull = style({ color: themeVars.color['text-secondary'] }, 'log-json-formatter-null');

/** Humanized timestamp annotation, muted, trailing the raw value. */
export const timestamp = style(
  {
    color: themeVars.color['text-secondary'],
    marginLeft: themeVars.space['100'],
  },
  'log-json-formatter-timestamp',
);

/** Inline wrapper so the Pluma Label sits neatly between the key and the colon. */
export const badge = style(
  {
    display: 'inline-flex',
    verticalAlign: 'middle',
    margin: `0 ${themeVars.space['100']}`,
  },
  'log-json-formatter-badge',
);
